import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Card,
  CardContent,
  Chip,
  Grid,
  Tooltip,
  Snackbar,
  Alert
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { _delete, _get } from '../../Config/axiosInstance';

function OfferListPage() {
  const [offers, setOffers] = useState([]);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  const navigate = useNavigate();

  const fetchOffers = async () => {
    try {
      const response = await _get('/getoffers');
      if (Array.isArray(response.data.data)) {
        setOffers(response.data.data);
      } else {
        console.error('Unexpected response format:', response.data);
      }
    } catch (error) {
      console.error('Failed to fetch offers:', error);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const handleAddNew = () => {
    navigate('/AddOfferPage');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;

    try {
      await _delete(`/deleteoffer/${id}`);
      setAlert({ open: true, message: 'Offer deleted successfully.', severity: 'success' });
      fetchOffers();
    } catch (err) {
      console.error(err);
      setAlert({ open: true, message: 'Failed to delete offer.', severity: 'error' });
    }
  };

  const handleEdit = (id) => {
    navigate(`/EditOfferPage/${id}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="primary.main">
          🎁 Current Offers
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          color="success"
          sx={{ borderRadius: 2, px: 3 }}
          onClick={handleAddNew}
        >
          Add New Offer
        </Button>
      </Box>

      <Grid container spacing={3}>
        {offers?.map((offer, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 6,
                p: 2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: 10
                }
              }}
            >
              <CardContent>
                <Typography variant="h6" color="text.primary" gutterBottom>
                  {offer.offerName}
                </Typography>

                <Box sx={{ mb: 1 }}>
                  <Chip label={`Expires in ${offer.offerexpiry} months`} color="info" sx={{ mr: 1, mb: 1 }} />
                  <Chip label={`🎟 ${offer.offermovietickets} Tickets`} color="primary" sx={{ mr: 1, mb: 1 }} />
                  <Chip label={`🍔 ${offer.offerfooddiscount}% Food Off`} color="secondary" sx={{ mb: 1 }} />
                </Box>

                {offer.offerother && (
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                    <strong>Other:</strong> {offer.offerother}
                  </Typography>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Tooltip title="Edit Offer">
                    <IconButton onClick={() => handleEdit(offer.offerId)} color="warning">
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Offer">
                    <IconButton onClick={() => handleDelete(offer.offerId)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert severity={alert.severity} variant="filled">
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default OfferListPage;
